import React from 'react'
import PropTypes from 'prop-types'

import Button from '@/checkout-instore-legacy/components/Commons/Elements/Button'
import { clearAllCache } from '@/checkout-instore-legacy/cache/utils'

const Info = ({
  message,
  title,
  titleExtraStyle,
  Icon,
  giveUp,
  retry,
  retryText,
  giveUpText,
  extraButton,
}) => (
  <div className="aspect-ratio--object aspect-ratio-l h-100-l flex flex-column items-center justify-center tc z-9999 f3-ns">
    <div className="flex-none">
      {Icon}
      <div className={`mt5 mt6-ns mb6 mb7-ns mb5-l ${titleExtraStyle}`}>
        {title}
      </div>
      {message ? (
        <div className="mb5 mb7-ns ph5 ph7-ns lh-copy mb6-l f4-l">
          {message}
        </div>
      ) : null}
      {retry ? (
        <div className="dib mv4 mb6-l">
          <Button
            id="root-retry-btn"
            kind="primary"
            size="lg"
            lonely={false}
            onClick={retry}
          >
            {retryText}
          </Button>
        </div>
      ) : null}
      {giveUp ? (
        <Button
          id="root-giveup-btn"
          kind="light-primary"
          size="lg"
          lonely={false}
          onClick={() => {
            clearAllCache().finally(() => {
              giveUp()
              window.location.reload()
            })
          }}
        >
          {giveUpText}
        </Button>
      ) : null}
      {extraButton}
    </div>
  </div>
)

Info.defaultProps = {
  retryText: 'Tentar novamente',
  giveUpText: 'Cancelar',
}

Info.propTypes = {
  title: PropTypes.string.isRequired,
  titleExtraStyle: PropTypes.string,
  Icon: PropTypes.element,
  message: PropTypes.string,
  retry: PropTypes.func,
  giveUp: PropTypes.func,
  retryText: PropTypes.string,
  giveUpText: PropTypes.string,
  extraButton: PropTypes.element,
}

export default Info
